import { ArticleDto } from "./article.dto";
import { MachineMeasurementDto } from "./machine-measurements.dto";
import { MachineDto } from "./machine.dto";
import { ProductionProcessDto } from "./production-process.dto";

/**
 * Represents a machine measurement value
 */
export class MachineMeasurementsValueDto {

    /**
     * Do not send this to the server
     */
    id?: number;

    /**
     * The value of the measurement
     */
    value!: string;

    /**
     * Do not send this to the server
     */
    machine?: MachineDto;

    /**
     * The id of the machine that this measurement belongs to (MachineDto)
     */
    machineId!: number;

    /**
     * Do not send this to the server
     */
    machineMeasurement?: MachineMeasurementDto;

    /**
     * The id of the measurement unit (MachineMeasurementDto)
     */
    machineMeasurementId!: number;

    /**
     * Do not send this to the server
     */
    article?: ArticleDto;

    /**
     * The id of the article that this measurement belongs to (ArticleDto)
     */
    articleId?: number | null;

    /**
     * Do not send this to the server
     */
    productionProcess?: ProductionProcessDto;

    /**
     * The id of the production process that this measurement belongs to (ProductionProcessDto)
     */
    productionProcessId?: number | null;

    /**
     * The formatted value to be displayed, do not sent to the server
     */
    formattedValue?: string;

    /**
     * Needed to delete value
     */
    frontId?: string;
}
